import { render, staticRenderFns } from "./MyGy2.vue?vue&type=template&id=0ff639b7&"
import script from "./MyGy2.vue?vue&type=script&lang=js&"
export * from "./MyGy2.vue?vue&type=script&lang=js&"
import style0 from "./MyGy2.vue?vue&type=style&index=0&id=0ff639b7&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports